import 'zone.js'
;(window as any).global = window

import '@angular/localize/init'
import 'core-js/es/object/has-own'
